import About1 from "../../Images/About1.webp";
import About2 from "../../Images/About2.webp";
import searchPage1 from "../../Images/searchPage1.webp";
import searchPage2 from "../../Images/searchPage2.webp";
import searchPage3 from "../../Images/searchPage3.webp";
import searchPage4 from "../../Images/searchPage4.webp";
import searchPage5 from "../../Images/searchPage5.webp";
import searchPage6 from "../../Images/searchPage6.webp";
import searchPage7 from "../../Images/searchPage7.webp";
import searchPage8 from "../../Images/searchPage8.webp";
// import searchPage9 from "../../Images/searchPage9.webp";
// import searchPage10 from "../../Images/searchPage10.webp";
import tripImage1 from "../../Images/TripImage1.jpg";
import tripImage2 from "../../Images/TripImage2.jpg";
import tripImage3 from "../../Images/TripImage3.jpg";
import tripImage4 from "../../Images/TripImage4.jpg";

const SearchImages = [
    {
        image:searchPage1,
        blurHash:"LgPGy@%1ofof?wRkWBayR4s.a|j["
    },
    {
        image:searchPage2,
        blurHash:"LuNTdwNHM{of?wR-WCWCVsa}kCWB"
    },
    {
        image:searchPage3,
        blurHash:"LXCjton$IVbH.TaeR*j[t-WWj[oL"
    },
    {
        image:searchPage4,
        blurHash:"L~MkCGkCNGayysayWXfkbboKWFj["
    },
    {
        image:searchPage5,
        blurHash:"LuIgcCM|NHo0~UWAjsayS5xYs,R+"
    },
    {
        image:searchPage6,
        blurHash:"LVHo8uX9IAWV_N%MMxozNdxue.NG"
    },
    {
        image:searchPage7,
        blurHash:"LWHxg6Td00Q-_NwJD%kW-;o0R*bb"
    },
    {
        image:searchPage8,
        blurHash:"LhFE+mNHNFof~WNGR%oe^lRjWVof"
    },
]
const TripImages = [
    {
        image:tripImage1,
        blurHash:"LzIhT^IpxuRj~WRkaeay-;t8M{of"
    },
    {
        image:tripImage2,
        blurHash:"LzIhT^IpxuRj~WRkaeay-;t8M{of"
    },
    {
        image:tripImage3,
        blurHash:"LVFsreictRs:?^R*MwV@IUNGIAWB"
    },
    {
        image:tripImage4,
        blurHash:"LzIhT^IpxuRj~WRkaeay-;t8M{of"
    }
]
const AboutImages = [
    {
        image:About1,
        blurHash:"LAKA~S+ttlt71--okqbb0g0L+[rq"
    },
    {
        image:About2,
        blurHash:"LQKV8Wt8_NV?_NR+IUWBO[jFQ-t6"
    }
]
export {SearchImages,AboutImages,TripImages};